(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('PlanningVersionsController', PlanningVersionsController);

    PlanningVersionsController.$inject = ['entity', 'previousState', '$window', 'SoopkitchenUtils', 'Planning', '$stateParams', 'PlanTypes', '$uibModal', '$scope', '$cookies', '$http'];

    function PlanningVersionsController(entity, previousState, $window, SoopkitchenUtils, Planning, $stateParams, PlanTypes, $uibModal, $scope, $cookies, $http) {
        var vm = this;

        /** ** Properties *** */

        vm.planType = $stateParams.planType;
        vm.isMaster = vm.planType === PlanTypes['master'];
        vm.isChild = vm.planType === PlanTypes['child'];
        vm.isTemplate = vm.planType === PlanTypes['template'];
        vm.isSoop = vm.planType === PlanTypes['soop'];
        vm.planning = entity;
        vm.previousState = previousState.name;
        vm.previousParams = previousState.params;
        vm.checkedBaselines = true;
        vm.checkedBookmarks = true;
        vm.checkedAll = false;
        vm.checkedInstrument = {};
        vm.showDelta = {};
        vm.checkedAllInstrument = true;
        vm.checkedEvents = true;
        vm.ascending = false;
        vm.predicate = null;
        vm.lastBaselineChecked = false;
        vm.lastBaselineChecked = false;
        vm.selectedToDelete = null;
        vm.versionsToDelete = ['before last baseline', 'all but baselines', 'all but bookmarks'];
        vm.selectedBaselineToDelete = null;
        vm.baselinesToDelete = [];
        vm.isLtp = vm.planning.label.startsWith('LTP');
        /**** Functions ****/

        vm.sortTable = sortTable;
        vm.clone = clone;
        vm.displayVersion = displayVersion;
        vm.checkAllInstruments =checkAllInstruments;
        vm.uncheckAllInstruments = uncheckAllInstruments;
        vm.checkEvents =checkEvents;
        vm.uncheckEvents = uncheckEvents;
        vm.downloadFile = downloadFile;
        vm.downloadComparison = downloadComparison;
        vm.simulatePlan = simulatePlan;
        vm.draftS15TDR = draftS15TDR; // Added this line
        vm.plotPlanEps = plotPlanEps;
        vm.plotPlanLatency = plotPlanLatency;
        vm.donwloadResults = donwloadResults;
        // vm.commitSimulation = commitSimulation;
        vm.plotsGeneration = plotsGeneration;
        vm.editTDR = editTDR;
        vm.commitPush = commitPush;
        vm.rollback = rollback;
        vm.sanityChecks = sanityChecks;
        vm.instrumentChecked = instrumentChecked;
        vm.uncheckInstrument = uncheckInstrument;
        vm.checkInstrument = checkInstrument;
        vm.toggleBaselines = toggleBaselines;
        vm.toggleBookmarks = toggleBookmarks;
        vm.toggleAllVersions = toggleAllVersions;
        vm.deleteVersions = deleteVersions;
        /**** Init ****/

        checklocks(vm.planning.label);
        getPlans();
        vm.instruments = createInstrumentCheckbox();
        vm.checkedAll  = getBooleanFromCookie("checkedAll");
        vm.checkedBookmarks  = getBooleanFromCookie("checkedBookmarks");
        vm.checkedBaselines  = getBooleanFromCookie("checkedBaselines");
        vm.checkedEvents  = getBooleanFromCookie("checkedEvents");

        function getBooleanFromCookie(name) {
            if ($cookies.get(name) == null && name === "checkedAll") return false;
            if ($cookies.get(name) == null) return true;
            return JSON.parse($cookies.get(name));
        }
        function getJSONFromCookie(name) {
            if ($cookies.get(name) == null) return null;
            return JSON.parse($cookies.get(name));
        }
        function toggleAllVersions (){
            vm.checkedAll=!vm.checkedAll;
            if (vm.checkedAll) {
                vm.checkedBookmarks=true;
                vm.checkedBaselines=true;
            }
            storeCookies();
        }

        function deleteVersions() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-versions-maintenance.html',
                controller: 'PlanningVersionsMaintenanceController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    parameters: {
                        planType: vm.planType,
                        planLabel: vm.planning.label,
                        selectedBaselineToDelete: vm.selectedBaselineToDelete,
                    }
                }
            }).result.then(function () {
            }, function () {
            });
        }

        function toggleBookmarks (){
            vm.checkedBookmarks=!vm.checkedBookmarks;
            storeCookies();
        }
        function toggleBaselines (){
            vm.checkedBaselines=!vm.checkedBaselines;
            storeCookies();
        }
        function uncheckInstrument(instrument) {
            vm.checkedInstrument[instrument] = false;
            vm.checkedAllInstrument = false;
            storeCookies();

        }
        function checkInstrument(instrument) {
            vm.checkedInstrument[instrument]=true;
            storeCookies();
        }

        function isInstrumentRelated(delta) {
            for (var i = 0; i < vm.instruments.length; i++) {
                var instrument = vm.instruments[i];
                if (delta.indexOf(instrument)>-1) {
                    return true;
                }
            }
            return false;
        }

        function extractPositions(delta, instrument) {
            var positions = [];
            var pos = delta.prettyString.indexOf(instrument);

            while (pos > -1) {
                positions.push(pos);
                pos = delta.prettyString.indexOf(instrument, pos + 1);
            }
            return positions;
        }

        function instrumentChecked(plan) {
            if (plan.internalVersion === vm.planning.internalVersion ||
                vm.checkedAllInstrument) {
                return true;
            }
            var atLeastOneInstrumet = false;
            for (var count in plan.deltas) {
                var delta = plan.deltas[count];
                if (delta.hasOwnProperty("prettyString")) {
                    for (var instrument in vm.checkedInstrument) {
                        if (vm.checkedInstrument[instrument]) {
                            atLeastOneInstrumet = true;
                            if (delta.prettyString.indexOf(instrument)>-1) {
                                // Positions in the delta where the instrument ID is present:
                                var positions = extractPositions(delta, instrument);
                                for (var position in positions) {
                                    // It should have MAG, but not IMAGE
                                    if (instrument === "MAG") {
                                        var restStringShifted1Char = delta.prettyString.substring(position-1);
                                        var indexImage = restStringShifted1Char.indexOf("IMAGE");
                                        var indexMagTop = restStringShifted1Char.indexOf("_MAGTOP");
                                        if (indexImage < 0 && indexMagTop<0) {
                                            return true;
                                        }
                                    } else {
                                        return true;
                                    }
                                }
                            }
                        }
                    }

                    if (vm.checkedEvents && (delta.prettyString.includes("Event"))) {
                        return true;
                    }

                    if (atLeastOneInstrumet === false &&
                        isInstrumentRelated(delta.prettyString) === false &&
                        delta.prettyString.includes("Event") === false
                    ) {
                        return true;
                    }
                }

            }

            return false;

        }
        function checklocks(label) {
            Planning.getMeta(
                {
                    id: label
                },
                function successCallback(response) {
                    vm.locked = response.locked;
                },
                function errorCallback(response) {
                }
            )
        }

        function getPlans() {
            Planning.getAllVersions(
                {
                    planType: vm.planType,
                    id: vm.planning.label,
                },
                function successCallback(response) {
                    vm.plans = response;
                    for (var count in vm.plans) {
                        if (vm.plans.hasOwnProperty(count)) {
                            var plan = vm.plans[count];
                            vm.showDelta[plan.internalVersion] = false;
                            if (plan.baselineVersion !==0 && plan.baselineVersion !==undefined) {
                                vm.baselinesToDelete.push(plan.baselineVersion) ;
                            }
                        }
                    }
                },
                function errorCallback(response) {
                }
            )
        }

        function downloadFile (plan) {
            $window.open('api/' + vm.planType + '/export/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion);
        }

        function downloadComparison (plan) {
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/export-comparison/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion,
                responseType: 'text'
            }).then(function successCallback(response) {
                var reportContent = response.data;
                var title = 'Event Comparison Report';
                var msg = '<div class="resizable-content">' +
                          '<pre class="log-content">' + reportContent + '</pre>' +
                          '</div>';
                msg += '<h4>Would you like to download the report?</h4>';

                confirmAction(title, msg, 'info', function () {
                    var blob = new Blob([reportContent], {type: 'text/plain'});
                    var downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(blob);
                    downloadLink.download = plan.label + "_event_comparison.txt";
                    downloadLink.click();
                });
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }

        // those filenames are needed to identify the Python script to be executed
        function plotPlanLatency(plan) {
            plotPlan(plan, "Latency");
        }

        function plotPlanEps(plan) {
            plotPlan(plan, "Output");
        }

        function plotPlan(plan, filename) {
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/plot/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion + '/' + filename,
                responseType: 'arraybuffer'
            }).then(function successCallback(response) {
                var title ='Plots Generated Successfully :)';
                var msg = '<h4>Would you like to download results?</h4>';
                confirmAction(title, msg, 'success', function () {
                    donwloadZipFile(response);
                });
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }

        function simulatePlan(plan) {
            var title = 'Would you like to run the simulation?';

            var tableContainer = document.createElement('div');
            tableContainer.style.textAlign = 'center';

            var label = document.createElement('label');
            label.innerHTML = 'Use Local TDR';
            label.setAttribute('for', 'localTdrCheckbox');
            label.style.fontSize = '20px';
            label.style.display = 'inline-block';


            var checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.id = 'localTdrCheckbox';
            checkbox.style.display = 'inline-block';
            checkbox.style.verticalAlign = 'middle';
            checkbox.style.width = '7%'; // Set the width of the checkbox to 7%
            checkbox.style.boxShadow = 'none'; // Remove the box shadow
            checkbox.style.height = '20px'; // Set the height of the checkbox to 20px



            tableContainer.appendChild(label);
            tableContainer.appendChild(checkbox);

            SoopkitchenUtils.invokeSweetAlertWithParams({
                title: title,
                text:  tableContainer.outerHTML,
                html: true,
                customClass: 'swal-wide',
                type: 'info',
                confirmButtonColor: "#DD6B55",
                animation: 'slide-from-top',
                showCancelButton: true,
                }, function (ok) {
                    if (ok) {
                        var checkboxValue = document.getElementById('localTdrCheckbox').checked;
                        var useLocalTDR = checkboxValue;
                        simulatePlanConfirmation(plan, useLocalTDR);
                    }
                });
        }

        function simulatePlanConfirmation(plan, useLocalTDR) {
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/simulate/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion + '/' + useLocalTDR,
            }).then(function successCallback(response) {
                var fileContent = response.data;
                var title = 'Simulation Executed Successfully :)';
                var msg = '<h3>' + plan.label + ' - Internal version: ' + plan.internalVersion + ' - Errors from "conflicts.out"' +'</h3>';
                // Filter to show only lines containing "ERROR"
                if (fileContent != "") {
                    var errorLines = fileContent.split('\n').filter(function(line) {
                        return line.includes("ERROR");
                    }).join('\n');
                    if (errorLines === "") {
                        errorLines = "No errors found in simulation.";
                    }
                    msg +=
                        '<div class="resizable-content">' +
                        '<pre class="log-content">' + errorLines + '</pre>' +
                        '</div>';
                }
                //var msg = "<img  height='200' width='200' src='content/images/happy-sun.jpeg'/> <br>"
                msg += '<h4>Would you like to download results?</h4>';

                // Display the message in your modal or UI component here
                confirmAction(title, msg, 'success', function () {
                    donwloadResults(plan, true);
                });
            }, function errorCallback(response) {
                if (response.status === 417) {
                    var fileContent = response.data;

                    var title = "Simulation Failed";
                    var msg = "<img  height='183' width='245' src='content/images/coyote-ouch.jpeg'/> <br>";
                    msg += '<h4>Would you like to download results?</h4>';
                    if (fileContent != "") {
                        msg += '<div class="resizable-content">' +
                            '<pre class="log-content">' + fileContent + '</pre>' +
                            '</div>';
                    }
                    confirmAction(title, msg, 'warning', function () {
                        donwloadResults(plan, true);
                    });
                } else {
                    SoopkitchenUtils.prettyError(response, function () {
                    });
                }
            });
        }

        function draftS15TDR(plan) {
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/draftS15TDR/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion,
            }).then(function successCallback(response) {
                SoopkitchenUtils.invokeSweetAlert("Nice!", "ADR and EFECS files successfully sent!", "success");
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }

        function confirmAction(title, message, type,  action) {
            SoopkitchenUtils.prettyHtml(title, message, type, function (ok) {
                if (ok) {
                    action();
                }
            });
        }

        function donwloadResults (plan, simul) {
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/downloadresults/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion + '/' + simul,
                responseType: 'arraybuffer'
            }).then(function successCallback(response) {
                donwloadZipFile(response);
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }


        function donwloadZipFile (response) {
            var contentDispositionHeader = response.headers('Content-Disposition');
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(contentDispositionHeader);
            var filename = matches[1].replace(/['"]/g, '');
            // create a blob from the zip file bytes
            var blob = new Blob([response.data], {type: 'application/zip'});
            // create a download link and click it to download the file
            var downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = filename;
            downloadLink.click();
        }


        function createDivPlot(name) {
            var divPlot = document.createElement('div');
            divPlot.setAttribute('id', name);
            //divPlot.style.border = '1px solid black';
            divPlot.style.width = '1205px';
            return divPlot;
        }

        function plotsGeneration (plan) {
            // table for Plots
            var tableContainer = document.createElement('div');
            tableContainer.style.overflow = 'auto';
            tableContainer.style.height = '75vh';
            tableContainer.style.minHeight = '20px';

            // Create a spinner
            var spinner = document.createElement('div');
            spinner.id = "plotSpinner";
            spinner.setAttribute('class', 'loading-spinner');

            // Append the spinner to the tableContainer
            tableContainer.appendChild(spinner);

            // Define an array of plot identifiers
            var plotIdentifiers = [
                'RsNorm', 'IsNorm', 'Rs', 'Is', 'TotalReal',
                'TotAccumDl', 'Und', 'RatesRs', 'RatesIs', 'OutputAccumFlsh',
                'Dl', 'NonSci', 'ISLat', 'RSLat', 'NonSciLat'
            ];
            // Dynamically create and append plots
            for (var i = 0; i < plotIdentifiers.length; i++) {
                tableContainer.appendChild(createDivPlot(plotIdentifiers[i]));
            }

            SoopkitchenUtils.invokeSweetAlertWithParams({
                title: "Plots",
                text: tableContainer.outerHTML,
                html: true,
                heightAuto: false,
                customClass: 'swal-full-screen',
                animation: 'slide-from-top',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: 'Save Plots',
                cancelButtonText: 'Cancel',
                closeOnConfirm: false
            }, function (ok) {
                if (ok) {
                    console.log("Saving plots...");
                    saveImages();
                }
            });
            // Execute the code block without waiting for user interaction
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/simulationFiles/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion,
                responseType: 'arraybuffer'  // Important: Ask for the data as raw binary
            }).then(function successCallback(response) {
                JSZip.loadAsync(response.data).then(function (zipFiles) {
                    var promises = [];
                    var dataArrLat = [];
                    var dataArrRateAvg = [];
                    var dataArrUnd = [];
                    var storeSizes = [];
                    var sci_sizes = [];

                    zipFiles.forEach(function (relativePath, zipEntry) {
                        console.log("File:", relativePath);
                        var promiseData = zipEntry.async('string').then(function (content) {
                            if (relativePath === "cyclic_ds_latency.out") {
                                fetchDataLat(content, dataArrLat);
                            } else if (relativePath === "data_rate_avg.out") {
                                fetchDataEps(content, dataArrRateAvg);
                            } else if (relativePath === "passes.out") {
                                fetchDataEpsPasses(content, dataArrUnd);
                            } else if (relativePath === "sol_memory.edf") {
                                fetchDataEpsMemory(content, storeSizes, sci_sizes);
                            }
                        }).catch(function (error) {
                            console.error("Error in zipEntry.async: ", error);
                        });
                        promises.push(promiseData);
                    });
                    // Wait for all promises to resolve
                    Promise.all(promises).then(function () {
                        // All promises have resolved, now call plotDataLat
                        plotDataLat(dataArrLat);
                        plotDataEps(dataArrUnd, dataArrRateAvg, storeSizes, sci_sizes);
                        // Remove the spinner after plotting the data
                        var docSpinner = document.getElementById("plotSpinner");
                        docSpinner.remove();
                    }).catch(function (error) {
                        console.error("Error in processing zip files: ", error);
                    });
                }).catch(function(error) {
                    console.error("Error in JSZip.loadAsync: ", error);
                });
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }

        function editTDR (plan) {
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/tdredition/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion,
            }).then(function successCallback(response) {
                var fileContent = response.data;

                var table = document.createElement('table');
                table.setAttribute('id', 'tdrTable');
                table.setAttribute('border', '3');

                // read row
                var rows = fileContent.split("\n");

                var rowsCount = 0;
                for (var rowIndex in rows) {
                    var row = rows[rowIndex];
                    var dataMain = row.split('=');

                    // date
                    // check if first element of the row is a valid date
                    var td;
                    if (valiDate(dataMain[0].trim())) {
                        var trHeader;
                        if (rowsCount === 0) {
                            trHeader = table.insertRow();
                            td = trHeader.insertCell();
                            td.innerHTML = '<label onclick="sortTableDate(0);" class="label-td">Date</label>';
                            td.style.backgroundColor = "#ADD8E6";
                            td.style.fontWeight = "bold";
                        }
                        var tr2 = table.insertRow();
                        td = tr2.insertCell();
                        td.innerHTML = dataMain[0];
                        td.setAttribute("contenteditable", "true");
                        td.setAttribute("onblur", "editCellDate(this)");
                        td.style.padding = "5px";
                        td.style.fontWeight = "bold";


                        // instruments ratio
                        var data = dataMain[1].trim().split(/\s+/);
                        var cont = 1;
                        var total = 0;
                        // ratio columns
                        for (var colIndex in data) {
                            var col = data[colIndex];
                            if (isWhitespace(col)) break;
                            if (cont % 2 === 0) {
                                td = tr2.insertCell();
                                total += parseFloat(col);
                                td.innerHTML = col;
                                td.setAttribute("contenteditable", "true");
                                td.setAttribute("onblur", "editCell(this)");
                                td.style.padding = "10px";
                            } else {
                                // header
                                if (rowsCount === 0) {
                                    td = trHeader.insertCell();
                                    col = col.replace(/^SSMM_|_SCI$/g, "");
                                    td.innerHTML = col;
                                    td.style.backgroundColor = "#ADD8E6";
                                    td.style.fontWeight = "bold";
                                }
                            }
                            cont++;
                        }
                        // total
                        if (rowsCount === 0) {
                            td = trHeader.insertCell();
                            td.innerHTML = "Total";
                            td.style.backgroundColor = "#ADD8E6";
                            td.style.fontWeight = "bold";
                        }
                        td = tr2.insertCell();
                        updateTotal(td, total);
                        // functions column
                        if (rowsCount === 0) {
                            td = trHeader.insertCell();
                            td.innerHTML = "Functions";
                            td.style.backgroundColor = "#ADD8E6";
                            td.style.fontWeight = "bold";
                        }
                        var comment = "";
                        var extractedComment = rows[rows.indexOf(row) - 1];

                        while (extractedComment && extractedComment.trim().charAt(0) === "#") {
                            if (comment === "")
                                comment = extractedComment.trim().substr(1);
                            else
                                comment = extractedComment.trim().substr(1) + "\n" + comment;
                            extractedComment = rows[rows.indexOf(extractedComment) - 1];
                        }

                        td = tr2.insertCell();
                        td.style.padding = "5px";
                        // Functions buttons
                        // button + to clone the row
                        // button - to remove the row
                        // button 'comment' to modify, add or remove the text for the row comment
                        td.innerHTML = '<label onclick="duplicateRow(this);" class="button-label">+</label> '
                            + '<label onclick="deleteRow(this);" class="button-label">-</label> '
                            + '<label class="button-label" onclick="toggleTextArea(this.parentElement)">Comment</label> '
                            + '<textarea style="display: none;" class="comment-textarea">' + comment + '</textarea>';
                        // increment rows counter
                        rowsCount++;
                    }
                }

                // Create the script element
                var script = document.createElement('script');
                script.setAttribute('src', 'tdr-functions.js');
                var tableBody = document.createElement('tbody');
                tableBody.appendChild(script);

                // Append the table body to the table
                table.appendChild(tableBody);

                var tableContainer = document.createElement('div');
                tableContainer.style.overflow = 'auto';
                tableContainer.style.maxHeight = '500px';
                tableContainer.appendChild(table);

                SoopkitchenUtils.invokeSweetAlertWithParams({
                    title: "TDR Editor",
                    text: tableContainer.outerHTML,
                    html: true,
                    type: 'info',
                    customClass: 'swal-super-wide',
                    animation: 'slide-from-top',
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55"
                    }, function (ok) {
                        if (ok) {
                            var tdrText = generateTdrText('ltp');
                            saveTDR(plan, tdrText);
                        }
                    }
                );
            }, function errorCallback(response) {
                //console.error(error);
                SoopkitchenUtils.prettyError(response);
            });
        }

        function saveTDR(plan, tdrText) {
            $http({
                method: 'POST',
                url: 'api/' + vm.planType + '/saveTdr/' + encodeURIComponent(plan.label) + '/' + plan.internalVersion,
                data: JSON.stringify(tdrText),
            }).then(function successCallback(response) {
                //console.log(tdrText);
                SoopkitchenUtils.invokeSweetAlert("Nice!", "TDR changes saved", "success");
                //successCallback();
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }

        function commitPush(plan) {
            var title = 'Commit Plan files';

            var tableContainer = document.createElement('div');
            tableContainer.style.textAlign = 'center';

            var label = document.createElement('label');
            label.innerHTML = 'Would you like the files from the plan to be committed and pushed to the repository?';
            label.style.display = 'block'; // Set display property to block

            var textArea = document.createElement('textarea');
            textArea.id = 'commit-message';
            textArea.style.display = 'block';
            textArea.style.width = '100%';
            textArea.rows = 5;
            textArea.placeholder = 'Enter your commit message here...';

            tableContainer.appendChild(label);
            tableContainer.appendChild(textArea);

            SoopkitchenUtils.invokeSweetAlertWithParams({
                title: title,
                text: tableContainer.outerHTML,
                html: true,
                customClass: 'swal',
                type: 'info',
                confirmButtonColor: "#DD6B55",
                animation: 'slide-from-top',
                showCancelButton: true,
            }, function (ok) {
                if (ok) {
                    $http({
                        method: 'POST',
                        url: 'api/' + vm.planType + '/commitPush/' + encodeURIComponent(plan.label) + '/' + plan.internalVersion,
                        data: angular.toJson(document.getElementById("commit-message").value),
                    }).then(function successCallback(response) {
                        SoopkitchenUtils.invokeSweetAlert("Nice!", "Changes have been committed", "success");
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    });
                }
            });
        }

        function toggleAllInstruments(value) {
            for (var i = 0; i < vm.instruments.length; i++) {
                var instrument = vm.instruments[i];
                vm.checkedInstrument[instrument] = value;
            }
            vm.checkedAllInstrument = value;
            vm.checkedEvents = value;
            storeCookies();
        }

        function checkAllInstruments() {
            toggleAllInstruments(true);
        }
        function uncheckAllInstruments () {
            toggleAllInstruments(false);
        }
        function checkEvents() {
            vm.checkedEvents = true;
        }
        function uncheckEvents () {
            vm.checkedEvents = false;
            vm.checkedAllInstrument = false;
        }
        function createInstrumentCheckbox() {
            var groupsArray = [];
            var obsDef = vm.planning.observationDefinitions.allExperimentsObservationDefinitions;
            var storedCheckedInstrument = getJSONFromCookie("checkedInstrument");
            for (var experiment in obsDef) {
                if (vm.planning.observationDefinitions.allExperimentsObservationDefinitions.hasOwnProperty(experiment)) {
                    groupsArray.push(experiment);
                    if (storedCheckedInstrument != null) {
                        vm.checkedInstrument[experiment] = storedCheckedInstrument[experiment];
                    } else {
                        vm.checkedInstrument[experiment] = true;
                    }
                }
            }
            vm.checkedAllInstrument  = getBooleanFromCookie("checkedAllInstrument");

            return groupsArray;
        }


        function displayVersion(plan) {
            return plan.internalVersion === vm.planning.internalVersion || vm.checkedAll === true
                || (vm.checkedBookmarks === true && plan.isBookmarked === true) || (plan.baselineVersion !== 0 && vm.checkedBaselines === true);
        }


        function rollback (internalVersion) {
            SoopkitchenUtils.prettyConfirm('Rollback', 'Do you really want to rollback to internalversion ' + internalVersion
                + ' ? ', function (ok) {
                if (ok) {
                    doRollBack(internalVersion);
                }
            });
        }

        function sanityChecks(internalVersion) {
            $http({
                method: 'GET',
                url: 'api/plan/checks/' + vm.planning.label + '/' + internalVersion,
            }).then(function successCallback(response) {
                SoopkitchenUtils.sanityChecksResult(response);
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }


        function doRollBack(internalVersion) {
            Planning.rollback(
                {
                    planType: vm.planType,
                    planLabel: vm.planning.label,
                    internalVersion: internalVersion
                },
                function successCallback(response) {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", "You rolledback the plan " + vm.planning.label + "to version: " + internalVersion, "success");
                    checklocks(vm.planning.label);
                    getPlans();
                    createInstrumentCheckbox();
                },
                function errorCallback(response) {
                }
            )
        }

        function clone(internalVersion) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/clone-plan.html',
                controller: 'ClonePlanController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    parameters: {
                        planType: vm.planType,
                        labelToClone: vm.planning.label,
                        internalVersionToClone: internalVersion,
                    }
                }
            }).result.then(function () {
            }, function () {
            });
        }
        function sortTable() {
            vm.plans = SoopkitchenUtils.sort(vm.plans, vm.predicate, !vm.ascending);
            $scope.$apply();
        }

        function storeCookies() {
            $cookies.put("checkedInstrument", JSON.stringify(vm.checkedInstrument));
            $cookies.put("checkedAllInstrument", vm.checkedAllInstrument);
            $cookies.put("checkedAll", vm.checkedAll);
            $cookies.put("checkedBookmarks", vm.checkedBookmarks);
            $cookies.put("checkedBaselines", vm.checkedBaselines);
            $cookies.put("checkedEvents", vm.checkedEvents);

        }
    }

    // TDR
    // date format validator
    function valiDate(dateInput) {
        var regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
        return regex.test(dateInput);
    }

    // check there are no whitespaces
    function isWhitespace(str) {
        return str.trim().length === 0;
    }

    // total color update
    function updateTotal(td, total) {
        td.innerHTML = total.toFixed(3);// round to 3 decimal places
        td.style.color = "white";
        td.style.backgroundColor = "red";
        var oneHandred = 100;
        if (total.toFixed(3) === oneHandred.toFixed(3)) {
            td.style.backgroundColor = "blue";
        }
    }

    // generate tdr
    function generateTdrText(type) {
        if (sortTableDate(0) === "desc"){
            sortTableDate(0);
        }
        var table = document.getElementById("tdrTable");
        var rows = table.rows;
        var headerCells = rows[0].cells;

        // TDR header
        var result = 'VIRTUAL_CHANNEL VC2  # The label of this Virtual Channel\n';
        // particular part of the header depending on ltp or mtp
        if (type === "ltp") {
            result = result + 'EVENT_NAME SSMM_DUMP_1WAY_END SSMM_DUMP_2WAY_END';
        } else if (type === "mlp") {
            result = result + 'EVENT_NAME PASS_END';
        }
        result = result + "\n\nDS_NAMES SSMM_EPD_SCI SSMM_EUI_SCI SSMM_MAG_SCI SSMM_MET_SCI SSMM_PHI_SCI SSMM_RPW_SCI SSMM_SHI_SCI SSMM_SPI_SCI SSMM_STX_SCI SSMM_SWA_SCI\n\n"
            + "LOW_PRIORITY 4 # Big number, low priority\n"
            + "HIGH_PRIORITY 1 # Low number, high priority\n\n";

        // ratios rows generation
        for (var i = 1; i < rows.length; i++) {
            var cells = rows[i].cells;
            //  add comment in case it exists
            var comment = rows[i].getElementsByClassName("comment-textarea")[0].value;
            var fullComment = null;
            if (!isWhitespace(comment)) {
                var lines = comment.split("\n");
                //fullComment = lines.map(line => "#" + line).join("\n") + "\n";
                fullComment = lines.map(function(line) {
                    return "#" + line;
                }).join("\n") + "\n";

            }
            //console.log(fullComment);
            if (fullComment !== null) result += fullComment;

            for (var j = 0; j < cells.length - 2; j++) {
                var cellValue = cells[j].textContent;
                var headerValue = headerCells[j].textContent;
                if (j === 0) {
                    result += cellValue + '= ';
                } else {
                    result += 'SSMM_' + headerValue + '_SCI ' + parseFloat(cellValue).toFixed(3) + ' ';
                }
            }
            result += '\n';
        }

        //console.log(result);
        return result;
    }

})();
